import {
  textBodyLarge,
  textCaption,
  textTitle3,
} from '../../../../growth-platform-brand-system-v2/src/styles/typography';
import { fontCaptionMedium } from '../../../../growth-platform-brand-system-v2/src/styles/typographyNew';
import { classNames } from '../../../../growth-platform-brand-system-v2/src/utils/style';

export enum CardType {
  BlogCard,
  InspirationalCard,
  WithoutBgCard,
  MenuCard,
  ResourceCard,
}

export const applyCapsTextStyle = (cardType: number) => {
  switch (cardType) {
    case CardType.BlogCard:
      return 'mb-12';
    case CardType.InspirationalCard:
      return 'mb-16';
    default:
      return 'mt-24';
  }
};

export const applyTagsStyle = (cardType: number) => {
  switch (cardType) {
    case CardType.InspirationalCard:
      return 'mb-16';
    case CardType.MenuCard:
      return 'mb-8';
    default:
      return 'mb-24';
  }
};

export const applyLogoStyle = (cardType: number) => {
  if (cardType === CardType.WithoutBgCard) return 'mb-24';

  return 'mb-16';
};

export const applyTitleStyle = (
  cardType: number,
  hasSubtitleHover: boolean,
  isHovered: boolean,
) => {
  switch (cardType) {
    case CardType.BlogCard: {
      return classNames(
        textBodyLarge,
        'line-clamp-3 sm:line-clamp-2 md:line-clamp-3',
        hasSubtitleHover && !isHovered ? 'h-auto sm:h-48 md:h-88' : 'h-auto',
      );
    }
    case CardType.InspirationalCard:
      return classNames(
        textTitle3,
        'line-clamp-4 h-88 sm:line-clamp-3 sm:h-64 md:line-clamp-4 md:h-136 md:-mb-12',
      );
    case CardType.MenuCard:
      return classNames(fontCaptionMedium, 'text-neutral-301');
    default:
      return classNames(
        textTitle3,
        'line-clamp-3 sm:line-clamp-2 sm:-mb-4 md:line-clamp-3 md:-mb-8',
      );
  }
};

export const applySubtitleStyle = (cardType: number) => {
  switch (cardType) {
    case CardType.BlogCard:
      return 'md:visible -mb-4 sm:mb-0';
    case CardType.InspirationalCard:
      return 'md:visible md:line-clamp-3 h-64';
    case CardType.MenuCard:
      return classNames(textCaption, '!text-12 sm:visible sm:block text-navy-90');
    default:
      return 'md:visible md:line-clamp-4';
  }
};

export const applyDisplaySubtitleOnSmallDeviceStyle = (cardType: number) => {
  switch (cardType) {
    case CardType.BlogCard:
      return 'line-clamp-6 sm:line-clamp-3';
    case CardType.WithoutBgCard:
      return 'line-clamp-6 sm:line-clamp-3';
    default:
      return '';
  }
};

export const applyHasSubtitleHoverStyle = (
  cardType: number,
  hasSubtitleHover: boolean,
) => {
  if (cardType === CardType.BlogCard)
    return hasSubtitleHover
      ? `md:block h-0 overflow-hidden md:group-hover:line-clamp-4 md:group-hover:h-88 transition-all duration-500 ease-in-out`
      : 'md:line-clamp-4';

  return '';
};

export const applyCtaButtonStyle = (cardType: number) => {
  if (cardType === CardType.WithoutBgCard) return 'mt-8';

  return 'mt-24';
};

export const applyCardContentWithoutTagStyle = (
  noTags: boolean,
  cardType: number,
  isLogo: boolean,
): string =>
  noTags && cardType !== CardType.WithoutBgCard && isLogo ? ' mt-[64px]' : '';
